'use client'

import useModal from '@/hooks/useModal'
import { useSearchParams } from 'next/navigation'
import { useCallback } from 'react'

export type AuthModalTab =
  | 'login'
  | 'register'
  | 'forgotPassword'
  | 'newPassword'
  | 'signInWithSolana'

export type AuthModalState = {
  isOpen: boolean
  onClose: () => void
  onOpen: (tab?: AuthModalTab) => void
  setTab: (tab: AuthModalTab) => void
  tab?: AuthModalTab
}

export function useAuthModal(): AuthModalState {
  const searchParams = useSearchParams()
  const { isOpen, open, update, close } = useModal<{ tab: AuthModalTab }>(
    'auth'
  )

  const onOpen = useCallback(
    (tab: AuthModalTab = 'login') => {
      open({ tab })
    },
    [open]
  )

  const onClose = useCallback(() => {
    close()
  }, [close])

  const setTab = useCallback(
    (tab: AuthModalTab) => {
      update({ tab })
    },
    [update]
  )

  const tab = isOpen ? (searchParams.get('tab') as AuthModalTab) : undefined

  return { isOpen, tab, onOpen, onClose, setTab }
}
